import React, { useState, useEffect } from 'react';
import { Drawer, Typography, Select, Button, message } from 'antd';
import {
    UserAddOutlined
} from '@ant-design/icons';
import { Formik } from "formik"
import * as Yup from "yup"
import * as Actions from "../../actions/roleActions"
import { connect } from "react-redux"

const key = 'updatable';
const { Option } = Select;
const { Title, Text } = Typography;

const AddAdmin = ({ visible, onClose, users, adminList, teams, addAdmin, getUsers, addAdminState, departments, getDepartments }) => {
    const [user, setUser] = useState();
    const [addSuccess, setAddSuccess] = useState(null);

    useEffect(() => {
        if (addAdminState.addAdminSuccess != addSuccess) {
            message.success({ content: 'Successfully added!', key, duration: 2 });
            setAddSuccess(addAdminState.addAdminSuccess)
        }
    }, [addAdminState.addAdminSuccess])

    const addPMValidationSchema = Yup.object({
        user: Yup.string()
            .required('Please select user'),
        team: Yup.string()
            .required("Please select team")
    });

    return (
        <>
            <Drawer
                title="Add Admin"
                placement="right"
                closable={false}
                onClose={onClose}
                visible={visible}
            >
                <Formik
                    initialValues={{ user: '', team: '' }}
                    validationSchema={addPMValidationSchema}
                    onSubmit={(values, { setSubmitting, resetForm }) => {
                        var user = JSON.parse(values.user);
                        var testUserId = adminList.findIndex((teamLeadValue) => teamLeadValue.userEmail == user.mail);
                        if (testUserId == -1) {
                            message.loading({ content: 'Loading...', key });
                            addAdmin(user.mail, user.value, user.label.split("...")[0], values.team)
                            setSubmitting(false);
                            resetForm({ user: '', team: '' });
                        } else {
                            message.error({ content: "User already exists", duration: 2 });
                            setSubmitting(false);

                        }

                    }}>
                    {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting,
                        setFieldValue
                    }) => (
                        <form >
                            <Text type="secondary">User</Text>

                            <Select showSearch={true} style={{ width: "100%" }}
                                name="user"
                                onChange={(value) => { setFieldValue("user", value) }}
                                onSearch={(value) => {
                                    getUsers(value);
                                }}
                                // onBlur={handleBlur}
                                value={values.user}
                            >
                                {users && users
                                .filter((item) => typeof item.mail === 'string' && item.mail.includes('millenniumitesp.com'))
                                .map((item) => {
                                    const name = item.label.split('.')[0]; 
                                    return <Option value={JSON.stringify(item)}>{name}</Option>;
                                })
                        }
                            </Select>
                            <Text type="danger">{errors.user && touched.user && errors.user}</Text>
                            <br />
                            <Text type="secondary">Team</Text>
                            <Select showSearch={true} style={{ width: "100%" }}
                                name="team"
                                onChange={(value) => { setFieldValue("team", value) }}
                                value={values.team}
                            >
                                {teams &&
                                    teams.map((item) => {
                                        return <Option value={item.teamid}>{item.teamName}</Option>
                                    })
                                }
                            </Select>
                            <Text type="danger">{errors.team && touched.team && errors.team}</Text>

                            <Button danger type="primary" onClick={handleSubmit} disabled={isSubmitting} style={{ marginTop: 10 }}>
                                <UserAddOutlined /> Add Admin
                                </Button>
                        </form>
                    )}
                </Formik>
            </Drawer>
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        addAdminState: state.roleReducers
    }
}
export default connect(mapStateToProps, Actions)(AddAdmin)
